// ====================================================
// VidyaTrack — Theme Context (Light / Dark mode)
// ====================================================

import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem("vt-theme") === "dark"; } catch { return false; }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.setAttribute("data-theme", "dark");
      localStorage.setItem("vt-theme", "dark");
    } else {
      root.removeAttribute("data-theme");
      localStorage.setItem("vt-theme", "light");
    }
  }, [dark]);

  const toggle = () => setDark(d => !d);

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}
